import React, { memo } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import RichTextEditor from '../../../components/richTextEditor2'
import PlaygroundApp from '../../../components/lexicalEditor/lexical-playground/src/App'

const TextEditorWithTitle = memo(function ({title, onChange, html, setLoading, loading, index,
    editorState, onChangeEditorState, onChangeHtml, currentHtml,
    questionNumberIndex, loadedFile, currentParas,
    wantToRemoveExtraSpaces
 }) {
  return (
    <Grid container>
      <Grid xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 2,
          }}
        >
          <Typography variant="h4">{title}</Typography>
        </Box>
      </Grid>
      <Grid xs={12} sx={{ display: "flex" }} container>
        <Grid md={8} xs={12} sx={{ marginRight: "20px" }}>
          {/* <RichTextEditor onChange={onChange} html={html} setLoading={setLoading}
                    index={index}
                    loading={loading}
                /> */}
          <PlaygroundApp
            html={html}
            editorState={editorState}
            onChangeEditorState={onChangeEditorState}
            onChangeHtml={onChangeHtml}
            i={index}
            questionNumberIndex={questionNumberIndex}
            loadedFile={loadedFile}
            currentParas={currentParas}
            setLoading={setLoading}
            loading={loading}
            wantToRemoveExtraSpaces={wantToRemoveExtraSpaces}
          />
        </Grid>
        <Grid
          md={3}
          xs={12}
          sx={{
            border: "1px solid black",
            padding: "10px",
            margin: "15px",
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: currentHtml }}></div>
        </Grid>
      </Grid>
    </Grid>
  );
})

export default TextEditorWithTitle